import { sendRequest } from '@infrastructure/api/api';
import type { ErrorResponse } from '@core/types/errorResponse';
import type ApiResponse from '@core/types/apiResponse';
import type {
  MembershipAsOf,
  MembershipHistoryResponse,
  MembershipMovementInput,
  MembershipOverrideInput,
  MembershipPreview,
  ReportMembership,
  ScopeReportMembership,
} from '../types';

type Api<T> = Promise<ApiResponse<T, ErrorResponse>>;

export function fetchMembershipAsOf(apiPath: string, effectiveDate: string): Api<MembershipAsOf> {
  return sendRequest<never, MembershipAsOf>(
    'GET',
    `${apiPath}/membership/as-of?effective_date=${encodeURIComponent(effectiveDate)}`
  );
}

export function fetchMembershipHistory(apiPath: string, months: number): Api<MembershipHistoryResponse> {
  return sendRequest<never, MembershipHistoryResponse>(
    'GET',
    `${apiPath}/membership/history?months=${months}`
  );
}

export function previewMembershipUpdate(apiPath: string, body: MembershipMovementInput): Api<MembershipPreview> {
  return sendRequest<MembershipMovementInput, MembershipPreview>('POST', `${apiPath}/membership/update/preview`, body);
}

export function saveMembershipUpdate(apiPath: string, body: MembershipMovementInput): Api<{ message: string }> {
  return sendRequest<MembershipMovementInput, { message: string }>('POST', `${apiPath}/membership/update`, body);
}

export function previewMembershipOverride(apiPath: string, body: MembershipOverrideInput): Api<MembershipPreview> {
  return sendRequest<MembershipOverrideInput, MembershipPreview>('POST', `${apiPath}/membership/override/preview`, body);
}

export function saveMembershipOverride(apiPath: string, body: MembershipOverrideInput): Api<{ message: string }> {
  return sendRequest<MembershipOverrideInput, { message: string }>('POST', `${apiPath}/membership/override`, body);
}

/** reportPath is church/{churchId}/department/{departmentId}/report/reporttag/{reportTagId}. */
export function fetchReportMembership(reportPath: string): Api<ReportMembership> {
  return sendRequest<never, ReportMembership>('GET', `${reportPath}/membership`);
}

/** reportPath is district/{districtId}/... or nation/{nationId}/department/{departmentId}/report/reporttag/{reportTagId}. */
export function fetchScopeReportMembership(reportPath: string): Api<ScopeReportMembership> {
  return sendRequest<never, ScopeReportMembership>('GET', `${reportPath}/membership`);
}
